import axios from 'axios';
import {IAlert} from "./Alert.types";
import {IAlertAnalytics} from "../Analytics/Analytics.types";

export default class AlertApi {
    static async getAlerts({ queryKey }){
        //eslint-disable-next-line
        const [_key, params, userId] = queryKey;
        try {
            let res = await axios.get(`/alerts/user/${userId}?_sort=alert_for_date:DESC`, { params })
            if (res){
                return {
                    records: res.data.alerts as IAlert[],
                    totalRecords: res.data.count,
                }
            }
        } catch (e) {
            console.error('Error getting alerts', e.message);
            return undefined;
        }
    }
    static async getAlertById({ queryKey }){
        //eslint-disable-next-line
        const [_key, alertId] = queryKey;

        try {
            let res = await axios.get(`/alerts/${alertId}`)
            if (res){
                return res.data as IAlertAnalytics;
            }
        } catch (e) {
            console.error(`Error getting alert by Id: ${alertId}`, e.message);
            return undefined;
        }

    }
}